import type { IntlShape } from 'react-intl'

import { createRoutes } from '../../routes'

export function getFooterData(intl: IntlShape) {
  const routes = createRoutes(intl.locale)
  const footerColumnsData = [
    {
      title: intl.formatMessage({
        id: 'footer.howItWorks',
        defaultMessage: 'How it works',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'footer.sliteAgent',
            defaultMessage: 'Slite Agent',
          }),
          url: routes.blog.agentAnnouncement(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.aiSearch',
            defaultMessage: 'AI Search',
          }),
          url: routes.aiSearch(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.features',
            defaultMessage: 'AI knowledge base',
          }),
          url: routes.solutions.knowledgeBase(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.integrations',
            defaultMessage: 'Integrations',
          }),
          url: routes.integrations.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.mcp',
            defaultMessage: 'MCP',
          }),
          url: routes.mcp(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.pricing',
            defaultMessage: 'Pricing',
          }),
          url: routes.pricing(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.changelog',
            defaultMessage: 'Changelog',
          }),
          url: routes.changelog.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.helpCenter',
            defaultMessage: 'Help center',
          }),
          url: routes.helpCenter.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.contactSupport',
            defaultMessage: 'Contact support',
          }),
          url: 'mailto:support@slite.com',
        },
      ],
    },
    {
      title: intl.formatMessage({
        id: 'footer.solutionsfor',
        defaultMessage: 'Solutions for',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'footer.itoperations',
            defaultMessage: 'IT & Operations',
          }),
          url: routes.solutions.itOperations(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.productengineering',
            defaultMessage: 'Product & Engineering',
          }),
          url: routes.solutions.productEngineering(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.customersupport',
            defaultMessage: 'Customer Support',
          }),
          url: routes.solutions.customerSupport(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.humanresources',
            defaultMessage: 'Human Resources',
          }),
          url: routes.solutions.humanResources(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.sales',
            defaultMessage: 'Sales',
          }),
          url: routes.solutions.sales(),
        },
      ],
    },
    {
      title: intl.formatMessage({
        id: 'footer.resources',
        defaultMessage: 'Resources',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'footer.templates',
            defaultMessage: 'Templates',
          }),
          url: routes.templates.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.learn',
            defaultMessage: 'Learn',
          }),
          url: routes.learn.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.webinars',
            defaultMessage: 'Webinars',
          }),
          url: routes.webinars.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.customers',
            defaultMessage: 'Customers',
          }),
          url: routes.customers.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.workflows',
            defaultMessage: 'Workflows',
          }),
          url: routes.workflows.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.downloadApps',
            defaultMessage: 'Download apps',
          }),
          url: routes.download(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.browserExtension',
            defaultMessage: 'Browser Extension',
          }),
          url: routes.browserExtension(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.newsletter',
            defaultMessage: 'Newsletter',
          }),
          url: routes.newsletter(),
        },
      ],
    },
    {
      title: intl.formatMessage({
        id: 'footer.slite',
        defaultMessage: 'Slite',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'footer.aboutUs',
            defaultMessage: 'About us',
          }),
          url: routes.about(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.blog',
            defaultMessage: 'Blog',
          }),
          url: routes.blog.index(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.careers',
            defaultMessage: 'Careers',
          }),
          url: routes.jobs(),
        },
        {
          title: intl.formatMessage({
            id: 'footer.pressKit',
            defaultMessage: 'Press kit',
          }),
          url: routes.external.pressKit.url,
        },
      ],
    },
    {
      title: intl.formatMessage({
        id: 'footer.compare',
        defaultMessage: 'Compare',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'footer.notion',
            defaultMessage: 'Notion',
          }),
          url: routes.compare.detail({ slug: 'alternative-to-notion' }),
        },
        {
          title: intl.formatMessage({
            id: 'footer.confluence',
            defaultMessage: 'Confluence',
          }),
          url: routes.compare.detail({ slug: 'alternative-to-confluence' }),
        },
        {
          title: intl.formatMessage({
            id: 'footer.guru',
            defaultMessage: 'Guru',
          }),
          url: routes.compare.detail({ slug: 'alternative-to-guru' }),
        },
        {
          title: intl.formatMessage({
            id: 'footer.googleDocs',
            defaultMessage: 'Google Docs',
          }),
          url: routes.compare.detail({ slug: 'alternative-to-google-docs' }),
        },
        {
          title: intl.formatMessage({
            id: 'footer.slab',
            defaultMessage: 'Slab',
          }),
          url: routes.compare.detail({ slug: 'alternative-to-slab' }),
        },
      ],
    },
  ]

  const footerLocales = [
    { id: 'en-US', defaultMessage: 'English' },
    { id: 'fr-FR', defaultMessage: 'Français' },
    { id: 'es-ES', defaultMessage: 'Español' },
    { id: 'de-DE', defaultMessage: 'Deutsch' },
    { id: 'nl-NL', defaultMessage: 'Nederlands' },
    { id: 'ja-JP', defaultMessage: '日本語' },
  ]

  return {
    footerColumnsData,
    footerLocales,
    footerBottomLinksData: [
      {
        title: intl.formatMessage({
          id: 'footer.legalInformation',
          defaultMessage: 'Legal Information',
        }),
        url: routes.legal.legalInformation(),
      },
      {
        title: intl.formatMessage({
          id: 'footer.privacy',
          defaultMessage: 'Privacy',
        }),
        url: routes.legal.privacy(),
      },
      {
        title: intl.formatMessage({
          id: 'footer.security',
          defaultMessage: 'Security',
        }),
        url: routes.legal.security(),
      },
      {
        title: intl.formatMessage({
          id: 'footer.userTerms',
          defaultMessage: 'User terms',
        }),
        url: routes.legal.terms(),
      },
      {
        title: intl.formatMessage({
          id: 'footer.customerTerms',
          defaultMessage: 'Customer terms',
        }),
        url: routes.legal.customerTerms(),
      },
    ],
  }
}
